module.exports = __webpack_public_path__ + "static/media/utanverdlaeri.9d5bc889.png";